@if(allStatus$.viewBlockDice()){
<div class="d-flex align-items-center justify-content-center w-100 flex-column position-vertical">

    @if(turning === player.player_id){
        <div class="d-flex align-items-center justify-content-center flex-column gap-3 w-100">
            <div class="d-icon">
                <svg  width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.07129 0.954774C8.07129 0.406551 8.51648 -0.0421383 9.06283 0.00315945C10.692 0.138237 12.2801 0.605149 13.7281 1.37907C15.4684 2.30933 16.9526 3.65445 18.0489 5.29528C19.1453 6.93612 19.8201 8.82201 20.0135 10.7859C20.2069 12.7498 19.913 14.7311 19.1578 16.5543C18.4027 18.3775 17.2095 19.9863 15.684 21.2383C14.1585 22.4902 12.3479 23.3466 10.4124 23.7316C8.47688 24.1165 6.47631 24.0183 4.58788 23.4454C3.0168 22.9688 1.56368 22.176 0.316148 21.1195C-0.10221 20.7652 -0.0997355 20.1332 0.287917 19.7455C0.675569 19.3579 1.30124 19.3622 1.72535 19.7096C2.73782 20.5389 3.90565 21.1638 5.16418 21.5456C6.74019 22.0237 8.40978 22.1057 10.0251 21.7844C11.6403 21.4631 13.1515 20.7484 14.4246 19.7036C15.6976 18.6588 16.6934 17.3162 17.3237 15.7946C17.9539 14.273 18.1992 12.6195 18.0378 10.9805C17.8763 9.34152 17.3132 7.76762 16.3982 6.39825C15.4832 5.02888 14.2446 3.9063 12.7922 3.12994C11.6323 2.50998 10.3647 2.12609 9.06233 1.99657C8.5168 1.94232 8.07129 1.503 8.07129 0.954774Z" fill="url(#paint0_linear_2486_1749)"/>
                    <defs>
                    <linearGradient id="paint0_linear_2486_1749" x1="8.07129" y1="-0.0378723" x2="0.928431" y2="20.4927" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0918203" stop-color="#71C55D" stop-opacity="0"/>
                    <stop offset="1" stop-color="#71C55D"/>
                    </linearGradient>
                    </defs>
                </svg>

            </div>
            <div class="txt-wait">
                <span>{{ 'cardInfo.txtWaitTurn' | translate }}</span>
            </div>
            <div class="d-line"></div>
            <div class="d-other-txt">
                <span>
                {{ 'cardInfo.txtCardWait' | translate }}
                </span>
            </div>
        </div>
        <div class="btn-group-info" [attr.data-active]="isActive(turning,player.player_id)">
            @if(isGoToFinish()){
                <button type="button" (click)="rollTheDice()" class="to-roll-the-dice" [disabled]="!allStatus$.isRollDice || !rdUse.connected() || !rdUse.gameStateReady()">
                    {{ 'dice.txtButton' | translate }}
                </button>
            }@else{
                <button type="button" class="to-roll-the-dice d-flex justify-content-center align-items-center gap-2" disabled="true">
                    <span>{{ 'dice.txtButtonPreload' | translate }}</span>
                    <span class="material-symbols-outlined">progress_activity</span>
                </button>
            }        
        </div>
    }@else{
        <div class="d-flex align-items-center justify-content-center flex-column gap-3 w-100">
            <div class="d-icon">
                <svg width="21" height="24" viewBox="0 0 21 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.07129 0.954774C8.07129 0.406551 8.51648 -0.0421383 9.06283 0.00315945C10.692 0.138237 12.2801 0.605149 13.7281 1.37907C15.4684 2.30933 16.9526 3.65445 18.0489 5.29528C19.1453 6.93612 19.8201 8.82201 20.0135 10.7859C20.2069 12.7498 19.913 14.7311 19.1578 16.5543C18.4027 18.3775 17.2095 19.9863 15.684 21.2383C14.1585 22.4902 12.3479 23.3466 10.4124 23.7316C8.47688 24.1165 6.47631 24.0183 4.58788 23.4454C3.0168 22.9688 1.56368 22.176 0.316148 21.1195C-0.10221 20.7652 -0.0997355 20.1332 0.287917 19.7455C0.675569 19.3579 1.30124 19.3622 1.72535 19.7096C2.73782 20.5389 3.90565 21.1638 5.16418 21.5456C6.74019 22.0237 8.40978 22.1057 10.0251 21.7844C11.6403 21.4631 13.1515 20.7484 14.4246 19.7036C15.6976 18.6588 16.6934 17.3162 17.3237 15.7946C17.9539 14.273 18.1992 12.6195 18.0378 10.9805C17.8763 9.34152 17.3132 7.76762 16.3982 6.39825C15.4832 5.02888 14.2446 3.9063 12.7922 3.12994C11.6323 2.50998 10.3647 2.12609 9.06233 1.99657C8.5168 1.94232 8.07129 1.503 8.07129 0.954774Z" fill="url(#paint0_linear_2486_1749)"/>
                    <defs>
                    <linearGradient id="paint0_linear_2486_1749" x1="8.07129" y1="-0.0378723" x2="0.928431" y2="20.4927" gradientUnits="userSpaceOnUse">
                    <stop offset="0.0918203" stop-color="#71C55D" stop-opacity="0"/>
                    <stop offset="1" stop-color="#71C55D"/>
                    </linearGradient>
                    </defs>
                </svg>
            </div>
            <div class="txt-wait">
                <span>{{ 'cardInfo.txtWaitTurnNPl' | translate }}</span>
            </div>
            <div class="d-line"></div>
            <div class="d-other-txt">
                <span>
                {{ 'cardInfo.txtCardWaitNpl' | translate }}
                </span>
            </div>
        </div>
    }

</div>
}
